import { render, staticRenderFns } from "./PreviewButton.vue?vue&type=template&id=8b640d16&"
import script from "./PreviewButton.vue?vue&type=script&lang=js&"
export * from "./PreviewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports